<template>
  <label class="inline-flex items-center mt-3">
    <input type="checkbox" v-bind="$attrs" :checked="value == trueValue" class="form-checkbox h-5 w-5 text-red-600" :value="value" @input="input" /><span class="ml-2 text-gray-700">{{ label }}</span>

  </label>
</template>

<script>
export default {
  name:'Checkbox',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
    },
    value:{
      type: [String,Number, Boolean],
    },
    trueValue: {
      type: [String,Number, Boolean],
      default: true,
    },
    falseValue: {
      type: [String,Number, Boolean],
      default: false,
    },
  },
  methods: {
    input({ target }){
      if(target.checked){
        this.$emit('input', this.trueValue)
      }  else {
        this.$emit('input', this.falseValue)
      }
    },
  },
}
</script>

<style>

</style>
